import {memo, useState} from "react";
import {Box} from "@chakra-ui/react";
import {SparklesIcon} from "@heroicons/react/16/solid";
import {Button} from "../../../../../components/ui/button";
import {GenerationWizard} from "./GenerationWizard";

export const DiagramPlaceholder = memo(() => {
  const [wizardOpen, setWizardOpen] = useState(false);

  return (
    <>
      <Box
        h="200px"
        border="1px dashed {colors.gray.300}"
        borderRadius="md"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="white"
      >
        <Button colorPalette="blue" variant="ghost" onClick={() => setWizardOpen(true)}>
          <SparklesIcon />
          Generate diagram with AI
        </Button>
      </Box>
      <GenerationWizard
        open={wizardOpen}
        onClose={() => setWizardOpen(false)}
        onComplete={() => setWizardOpen(false)}
      />
    </>
  );
});
